// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, :after, :before {
  box-sizing: border-box;
  border: 0 solid #e8e8e8;
}

:after, :before {
  --tw-content: "";
}

:host, html {
  -webkit-text-size-adjust: 100%;
  font-feature-settings: normal;
  font-variation-settings: normal;
  tab-size: 4;
  -webkit-tap-highlight-color: transparent;
  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;
  line-height: 1.5;
}

body {
  line-height: inherit;
  margin: 0;
}

hr {
  color: inherit;
  border-top-width: 1px;
  height: 0;
}

abbr:where([title]) {
  text-decoration: underline dotted;
}

h1, h2, h3, h4, h5, h6 {
  font-size: inherit;
  font-weight: inherit;
}

a {
  color: inherit;
  text-decoration: inherit;
}

b, strong {
  font-weight: bolder;
}

code, kbd, pre, samp {
  font-feature-settings: normal;
  font-variation-settings: normal;
  font-family: Menlo, Monaco, Consolas, Courier New, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-collapse: collapse;
  border-color: inherit;
  text-indent: 0;
}

button, input, optgroup, select, textarea {
  color: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  font-family: inherit;
  font-size: 100%;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
}

button, select {
  text-transform: none;
}

button, input:where([type="button"]), input:where([type="reset"]), input:where([type="submit"]) {
  -webkit-appearance: button;
  background-color: #0000;
  background-image: none;
}

:-moz-focusring {
  outline: auto;
}

:-moz-ui-invalid {
  box-shadow: none;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

blockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, hr, p, pre, fieldset {
  margin: 0;
}

fieldset, legend {
  padding: 0;
}

menu, ol, ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

dialog {
  padding: 0;
}

textarea {
  resize: vertical;
}

input::placeholder, textarea::placeholder {
  color: #9ca3af;
  opacity: 1;
}

[role="button"], button {
  cursor: pointer;
}

:disabled {
  cursor: default;
}

audio, canvas, embed, iframe, img, object, svg, video {
  vertical-align: middle;
  display: block;
}

img, video {
  max-width: 100%;
  height: auto;
}

[hidden] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/packages/frontend-libs/shared-assets/public/tailwind/css/preflight.min.css","webpack://./packages/frontend-libs/shared-assets/public/tailwind/css/preflight.min.css"],"names":[],"mappings":"AADiF;ECE/E,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,wCAAwC;EACxC,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*! preflight from tailwindcss v3.4.4 | MIT License | https://tailwindcss.com */ *,\n:after,\n:before {\n  border: 0 solid #e8e8e8;\n  box-sizing: border-box;\n} :after,\n:before {\n  --tw-content: \"\";\n} :host,\nhtml {\n  line-height: 1.5;\n  -webkit-text-size-adjust: 100%;\n  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-feature-settings: normal;\n  font-variation-settings: normal;\n  tab-size: 4;\n  -webkit-tap-highlight-color: transparent;\n} body {\n  line-height: inherit;\n  margin: 0;\n} hr {\n  border-top-width: 1px;\n  color: inherit;\n  height: 0;\n} abbr:where([title]) {\n  text-decoration: underline dotted;\n} h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n} a {\n  color: inherit;\n  text-decoration: inherit;\n} b,\nstrong {\n  font-weight: bolder;\n} code,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, Courier New, monospace;\n  font-feature-settings: normal;\n  font-size: 1em;\n  font-variation-settings: normal;\n} small {\n  font-size: 80%;\n} sub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n} sub {\n  bottom: -.25em;\n} sup {\n  top: -.5em;\n} table {\n  border-collapse: collapse;\n  border-color: inherit;\n  text-indent: 0;\n} button,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font-family: inherit;\n  font-feature-settings: inherit;\n  font-size: 100%;\n  font-variation-settings: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  margin: 0;\n  padding: 0;\n} button,\nselect {\n  text-transform: none;\n} button,\ninput:where([type=\"button\"]),\ninput:where([type=\"reset\"]),\ninput:where([type=\"submit\"]) {\n  -webkit-appearance: button;\n  background-color: transparent;\n  background-image: none;\n} :-moz-focusring {\n  outline: auto;\n} :-moz-ui-invalid {\n  box-shadow: none;\n} progress {\n  vertical-align: baseline;\n} ::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n} [type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n} ::-webkit-search-decoration {\n  -webkit-appearance: none;\n} ::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n} summary {\n  display: list-item;\n} blockquote,\ndd,\ndl,\nfigure,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\np,\npre {\n  margin: 0;\n} fieldset {\n  margin: 0;\n} fieldset,\nlegend {\n  padding: 0;\n} menu,\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n} dialog {\n  padding: 0;\n} textarea {\n  resize: vertical;\n} input::placeholder,\ntextarea::placeholder {\n  color: #9ca3af;\n  opacity: 1;\n} [role=\"button\"],\nbutton {\n  cursor: pointer;\n} :disabled {\n  cursor: default;\n} audio,\ncanvas,\nembed,\niframe,\nimg,\nobject,\nsvg,\nvideo {\n  display: block;\n  vertical-align: middle;\n} img,\nvideo {\n  height: auto;\n  max-width: 100%;\n} [hidden] {\n  display: none;\n}\n","*, :after, :before {\n  box-sizing: border-box;\n  border: 0 solid #e8e8e8;\n}\n\n:after, :before {\n  --tw-content: \"\";\n}\n\n:host, html {\n  -webkit-text-size-adjust: 100%;\n  font-feature-settings: normal;\n  font-variation-settings: normal;\n  tab-size: 4;\n  -webkit-tap-highlight-color: transparent;\n  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;\n  line-height: 1.5;\n}\n\nbody {\n  line-height: inherit;\n  margin: 0;\n}\n\nhr {\n  color: inherit;\n  border-top-width: 1px;\n  height: 0;\n}\n\nabbr:where([title]) {\n  text-decoration: underline dotted;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\nb, strong {\n  font-weight: bolder;\n}\n\ncode, kbd, pre, samp {\n  font-feature-settings: normal;\n  font-variation-settings: normal;\n  font-family: Menlo, Monaco, Consolas, Courier New, monospace;\n  font-size: 1em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub, sup {\n  vertical-align: baseline;\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n}\n\nsub {\n  bottom: -.25em;\n}\n\nsup {\n  top: -.5em;\n}\n\ntable {\n  border-collapse: collapse;\n  border-color: inherit;\n  text-indent: 0;\n}\n\nbutton, input, optgroup, select, textarea {\n  color: inherit;\n  font-feature-settings: inherit;\n  font-variation-settings: inherit;\n  font-family: inherit;\n  font-size: 100%;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  margin: 0;\n  padding: 0;\n}\n\nbutton, select {\n  text-transform: none;\n}\n\nbutton, input:where([type=\"button\"]), input:where([type=\"reset\"]), input:where([type=\"submit\"]) {\n  -webkit-appearance: button;\n  background-color: #0000;\n  background-image: none;\n}\n\n:-moz-focusring {\n  outline: auto;\n}\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n::-webkit-inner-spin-button, ::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\n\nsummary {\n  display: list-item;\n}\n\nblockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, hr, p, pre, fieldset {\n  margin: 0;\n}\n\nfieldset, legend {\n  padding: 0;\n}\n\nmenu, ol, ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\ndialog {\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\ninput::placeholder, textarea::placeholder {\n  color: #9ca3af;\n  opacity: 1;\n}\n\n[role=\"button\"], button {\n  cursor: pointer;\n}\n\n:disabled {\n  cursor: default;\n}\n\naudio, canvas, embed, iframe, img, object, svg, video {\n  vertical-align: middle;\n  display: block;\n}\n\nimg, video {\n  max-width: 100%;\n  height: auto;\n}\n\n[hidden] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
